import {Pipe, PipeTransform} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';

@Pipe({name: 'capitalizeFirstLetter'})

export class CapitalizeFirstLetterPipe implements PipeTransform {
	transform(value: string, allFistLetter: boolean): string | null {
		if (Utilities.isVoid(value)) {
			return null;
		}
		if (!allFistLetter) {
			return Utilities.capitalizeFirstLetter(value);
		}
		let result = '';
		for (const s of value.split(' ')) {
			result += Utilities.capitalizeFirstLetter(s) + ' ';
		}
		return result;
	}
}
